module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "loginModal"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n      BIOveikals\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "ui middle aligned grid"
  }, [_c('div', {
    staticClass: "column"
  }, [(_vm.storeStatus.error != '') ? _c('div', {
    staticClass: "ui negative message"
  }, [_vm._v("\n            Pārbaudi e-pastu un paroli!\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui  center aligned  form"
  }, [_c('div', {
    staticClass: "ui  segment"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui left icon input"
  }, [_c('i', {
    staticClass: "user icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.email),
      expression: "credentials.email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "E-pasts"
    },
    domProps: {
      "value": (_vm.credentials.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui left icon input"
  }, [_c('i', {
    staticClass: "lock icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.password),
      expression: "credentials.password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Parole"
    },
    domProps: {
      "value": (_vm.credentials.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "password", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "ui fluid large custom_brown button",
    class: {
      loading: _vm.storeStatus.loading
    },
    attrs: {
      "disabled": _vm.credentials.email == '' || _vm.credentials.password == ''
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Autorizēties")]), _vm._v(" "), _c('p', {
    staticClass: "ms-reset-password-link"
  }, [_c('a', {
    on: {
      "click": _vm.goToResetPage
    }
  }, [_vm._v("Atjaunot paroli")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ui horizontal divider"
  }, [_vm._v("\n            Vai\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "ui segment"
  }, [_c('div', {
    staticClass: "ui fluid custom_brown button",
    on: {
      "click": _vm.goToRegistratinPage
    }
  }, [_vm._v("\n            Jauns Klients\n\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "ui horizontal divider"
  }, [_vm._v("\n            Vai\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "ui segment"
  }, [_c('div', {
    staticClass: "ui fluid green button",
    on: {
      "click": _vm.createGuestToken
    }
  }, [_vm._v("\n              Atcelt\n            ")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-33164ad9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoginPage.vue
// module id = 337
// module chunks = 1